export default "__VITE_ASSET__bcJYM2t___"